import {
  ProductDetailsState,
  ProductDetailsStateAction,
  ProductDetailsStateActionTypes,
} from '../types'

const variantContainsSelectedAddon = (
  variantKey: string,
  { product, selectedOptions }: ProductDetailsState,
) => {
  if (!selectedOptions.addonSku) return false
  const selectedVariant = product.variants.find(
    variant => variant.key === variantKey,
  )
  const selectedVariantAddon = (selectedVariant?.addons || []).find(
    ({ sku }) => sku === selectedOptions.addonSku,
  )
  return !!selectedVariantAddon
}

export const productStateReducer = (
  state: ProductDetailsState,
  action: ProductDetailsStateAction,
): ProductDetailsState => {
  const { type, payload } = action

  switch (type) {
    case ProductDetailsStateActionTypes.SET_PRODUCT:
      return {
        ...state,
        product: payload.product,
        selectedOptions: {
          variantKey: payload.useMasterVariantAsDefault
            ? payload.product.masterVariant.key
            : '',
          quantity: 1,
          addonSku: null,
        },
        upsellProduct: payload.upsellProduct,
        departmentInfo: payload.departmentInfo,
      }
    case ProductDetailsStateActionTypes.SET_SELECTED_VARIANT:
      return {
        ...state,
        selectedOptions: {
          ...state.selectedOptions,
          variantKey: payload,
          addonSku: variantContainsSelectedAddon(payload, state)
            ? state.selectedOptions.addonSku
            : null,
        },
      }
    case ProductDetailsStateActionTypes.SET_QUANTITY:
      return {
        ...state,
        selectedOptions: {
          ...state.selectedOptions,
          quantity: payload,
        },
      }
    case ProductDetailsStateActionTypes.SET_ADDON_SKU:
      return {
        ...state,
        selectedOptions: {
          ...state.selectedOptions,
          addonSku: payload,
        },
      }
    default:
      return state
  }
}
